import * as createjs from 'createjs-module';

export class TrimCjShadow extends createjs.Shadow {
  constructor(color: string, offsetX: number, offsetY: number, blur: number) {
    super(color, offsetX, offsetY, blur);
  }
}
